import React from 'react';
import ReactStars from 'react-stars';
import { withTheme } from 'styled-components'


const RatingStars = props => (
  <ReactStars half={false} color2={props.theme.colors.pink} {...props} />
);

export default withTheme(RatingStars);



// WEBPACK FOOTER //
// ./src/components/RatingStars.jsx